/* eslint-disable max-len */
/* eslint-disable quotes */
export const emptyMol = () => ({
  nextAtom: 0,
  nextBond: 0,
  atoms: {},
  bonds: {},
  positions: {},
});

export const exampleMols = {
  'Cyclopropane': {
    atoms: {
      16: { idx: '16', element: 'C', charge: 0 },
      17: { idx: '17', element: 'C', charge: 0 },
      18: { idx: '18', element: 'C', charge: 0 },
    },
    bonds: {
      16: {
        start: '16',
        end: '17',
        idx: '16',
        order: 1,
      },
      17: {
        start: '17',
        end: '18',
        idx: '17',
        order: 1,
      },
      18: {
        start: '16',
        end: '18',
        idx: '18',
        order: 1,
      },
    },
    positions: { 16: [-44.018, 37.359, 0], 17: [54.363, 19.441, 0], 18: [-10.345, -56.801, 0] },
    nextAtom: 19,
    nextBond: 19,
    key: 'Cyclopropane',
  },
  'Cyclobutane': {
    nextAtom: 12,
    nextBond: 13,
    atoms: {
      8: { idx: '8', element: 'C', charge: 0 },
      9: { idx: '9', element: 'C', charge: 0 },
      10: { idx: '10', element: 'C', charge: 0 },
      11: { idx: '11', element: 'C', charge: 0 },
    },
    bonds: {
      8: {
        start: '8',
        end: '9',
        idx: '8',
        order: 1,
      },
      10: {
        start: '8',
        end: '10',
        idx: '10',
        order: 1,
      },
      11: {
        start: '10',
        end: '11',
        idx: '11',
        order: 1,
      },
      12: {
        start: '11',
        end: '9',
        idx: '12',
        order: 1,
      },
    },
    positions: {
      8: [-59.842, -37.669, 0],
      9: [-37.669, 59.842, 0],
      10: [37.669, -59.842, 0],
      11: [59.842, 37.669, 0],
    },
    key: 'Cyclobutane',
  },
  'Cyclopentane': {
    nextAtom: 13,
    nextBond: 15,
    atoms: {
      8: { idx: '8', element: 'C', charge: 0 },
      9: { idx: '9', element: 'C', charge: 0 },
      10: { idx: '10', element: 'C', charge: 0 },
      11: { idx: '11', element: 'C', charge: 0 },
      12: { idx: '12', element: 'C', charge: 0 },
    },
    bonds: {
      8: {
        start: '8',
        end: '9',
        idx: '8',
        order: 1,
      },
      10: {
        start: '8',
        end: '10',
        idx: '10',
        order: 1,
      },
      11: {
        start: '10',
        end: '11',
        idx: '11',
        order: 1,
      },
      13: {
        start: '9',
        end: '12',
        idx: '13',
        order: 1,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
    },
    positions: {
      8: [-67.114, -52.266, 0],
      9: [-70.448, 47.678, 0],
      10: [28.969, -79.98, 0],
      11: [85.018, 2.836, 0],
      12: [23.575, 81.733, 0],
    },
    key: 'Cyclopentane',
  },
  'Cyclohexane': {
    nextAtom: 14,
    nextBond: 17,
    atoms: {
      8: { idx: '8', element: 'C', charge: 0 },
      9: { idx: '9', element: 'C', charge: 0 },
      10: { idx: '10', element: 'C', charge: 0 },
      11: { idx: '11', element: 'C', charge: 0 },
      12: { idx: '12', element: 'C', charge: 0 },
      13: { idx: '13', element: 'C', charge: 0 },
    },
    bonds: {
      8: {
        start: '8',
        end: '9',
        idx: '8',
        order: 1,
      },
      10: {
        start: '8',
        end: '10',
        idx: '10',
        order: 1,
      },
      11: {
        start: '10',
        end: '11',
        idx: '11',
        order: 1,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
      15: {
        start: '9',
        end: '13',
        idx: '15',
        order: 1,
      },
      16: {
        start: '13',
        end: '12',
        idx: '16',
        order: 1,
      },
    },
    positions: {
      8: [-65.013, -75.982, 0],
      9: [-98.309, 18.312, 0],
      10: [33.296, -94.294, 0],
      11: [98.309, -18.312, 0],
      12: [65.013, 75.982, 0],
      13: [-33.296, 94.294, 0],
    },
    key: 'Cyclohexane',
  },
  'Cycloheptane': {
    nextAtom: 15,
    nextBond: 19,
    atoms: {
      8: { idx: '8', element: 'C', charge: 0 },
      9: { idx: '9', element: 'C', charge: 0 },
      10: { idx: '10', element: 'C', charge: 0 },
      11: { idx: '11', element: 'C', charge: 0 },
      12: { idx: '12', element: 'C', charge: 0 },
      13: { idx: '13', element: 'C', charge: 0 },
      14: { idx: '14', element: 'C', charge: 0 },
    },
    bonds: {
      8: {
        start: '8',
        end: '9',
        idx: '8',
        order: 1,
      },
      10: {
        start: '8',
        end: '10',
        idx: '10',
        order: 1,
      },
      11: {
        start: '10',
        end: '11',
        idx: '11',
        order: 1,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
      15: {
        start: '9',
        end: '13',
        idx: '15',
        order: 1,
      },
      17: {
        start: '13',
        end: '14',
        idx: '17',
        order: 1,
      },
      18: {
        start: '14',
        end: '12',
        idx: '18',
        order: 1,
      },
    },
    positions: {
      8: [-66.06, -94.424, 0],
      9: [-115.012, -7.225, 0],
      10: [32.636, -110.52, 0],
      11: [106.757, -43.392, 0],
      12: [100.487, 56.411, 0],
      13: [-77.357, 85.415, 0],
      14: [18.549, 113.736, 0],
    },
    key: 'Cycloheptane',
  },
  'Cyclooctane': {
    nextAtom: 16,
    nextBond: 21,
    atoms: {
      8: { idx: '8', element: 'C', charge: 0 },
      9: { idx: '9', element: 'C', charge: 0 },
      10: { idx: '10', element: 'C', charge: 0 },
      11: { idx: '11', element: 'C', charge: 0 },
      12: { idx: '12', element: 'C', charge: 0 },
      13: { idx: '13', element: 'C', charge: 0 },
      14: { idx: '14', element: 'C', charge: 0 },
      15: { idx: '15', element: 'C', charge: 0 },
    },
    bonds: {
      8: {
        start: '8',
        end: '9',
        idx: '8',
        order: 1,
      },
      10: {
        start: '8',
        end: '10',
        idx: '10',
        order: 1,
      },
      11: {
        start: '10',
        end: '11',
        idx: '11',
        order: 1,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
      15: {
        start: '9',
        end: '13',
        idx: '15',
        order: 1,
      },
      18: {
        start: '14',
        end: '12',
        idx: '18',
        order: 1,
      },
      19: {
        start: '13',
        end: '15',
        idx: '19',
        order: 1,
      },
      20: {
        start: '15',
        end: '14',
        idx: '20',
        order: 1,
      },
    },
    positions: {
      8: [-58.25, -116.953, 0],
      9: [-123.887, -41.509, 0],
      10: [41.509, -123.887, 0],
      11: [116.953, -58.25, 0],
      12: [123.887, 41.509, 0],
      13: [-116.953, 58.25, 0],
      14: [58.25, 116.953, 0],
      15: [-41.509, 123.887, 0],
    },
    key: 'Cyclooctane',
  },
  'Cyclononane': {
    nextAtom: 9,
    nextBond: 9,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '8',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 1,
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 1,
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 1,
      },
      8: {
        start: '7',
        end: '8',
        idx: '8',
        order: 1,
      },
    },
    positions: {
      0: [299.362, -100, 0],
      1: [212.759, -50, 0],
      2: [114.279, -67.365, 0],
      3: [50, -143.969, 0],
      4: [50, -243.969, 0],
      5: [114.279, -320.574, 0],
      6: [212.76, -337.939, 0],
      7: [299.362, -287.939, 0],
      8: [333.564, -193.969, 0],
    },
  },
  'empty': {
    nextAtom: 0,
    nextBond: 0,
    atoms: {},
    bonds: {},
    positions: {},
    key: 'empty',
  },
  'Pyrrole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Pyrrole',
  },
  'Pyrazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Pyrazole',
  },
  'Imidazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Imidazole',
  },
  '1,2,3-triazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: '1,2,3-triazole',
  },
  '1,2,4-triazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: '1,2,4-triazole',
  },
  'Tetrazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Tetrazole',
  },
  'Pyridine': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: 'Pyridine',
  },
  'Pyridazine': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: 'Pyridazine',
  },
  'Pyrimidine': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: 'Pyrimidine',
  },
  'Pyrazine': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: 'Pyrazine',
  },
  '1,3,5-triazine': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: '1,3,5-triazine',
  },
  'Furan': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'O', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Furan',
  },
  'Oxazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'O', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Oxazole',
  },
  'Isoxazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'O', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Isoxazole',
  },
  '1,2,3-oxadiazole': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'O', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: '1,2,3-oxadiazole',
  },
  'Morpholine': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'O', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 1,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: 'Morpholine',
  },
  'Thiophene': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'S', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Thiophene',
  },
  'Benzene': {
    nextAtom: 6,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
    },
    positions: {
      0: [200, -50, 0],
      1: [100, -50, 0],
      2: [50, -136.603, 0],
      3: [100, -223.205, 0],
      4: [200, -223.205, 0],
      5: [250, -136.603, 0],
    },
    key: 'Benzene',
  },
  'Naphtalene': {
    nextAtom: 10,
    nextBond: 11,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'C', charge: 0, idx: '9' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '9',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '8',
        idx: '5',
        order: 1,
      },
      6: {
        start: '4',
        end: '5',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 1,
      },
      8: {
        start: '6',
        end: '7',
        idx: '8',
        order: 2,
      },
      9: {
        start: '7',
        end: '8',
        idx: '9',
        order: 1,
      },
      10: {
        start: '8',
        end: '9',
        idx: '10',
        order: 2,
      },
    },
    positions: {
      0: [400, -136.603, 0],
      1: [350, -50, 0],
      2: [250, -50, 0],
      3: [200, -136.603, 0],
      4: [100, -136.603, 0],
      5: [50, -223.205, 0],
      6: [100, -309.808, 0],
      7: [200, -309.808, 0],
      8: [250, -223.205, 0],
      9: [350, -223.205, 0],
    },
    key: 'Naphtalene',
  },
  'Anthracene': {
    nextAtom: 14,
    nextBond: 16,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'C', charge: 0, idx: '9' },
      10: { element: 'C', charge: 0, idx: '10' },
      11: { element: 'C', charge: 0, idx: '11' },
      12: { element: 'C', charge: 0, idx: '12' },
      13: { element: 'C', charge: 0, idx: '13' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '13',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '12',
        idx: '5',
        order: 1,
      },
      6: {
        start: '4',
        end: '5',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 1,
      },
      8: {
        start: '5',
        end: '10',
        idx: '8',
        order: 1,
      },
      9: {
        start: '6',
        end: '7',
        idx: '9',
        order: 2,
      },
      10: {
        start: '7',
        end: '8',
        idx: '10',
        order: 1,
      },
      11: {
        start: '8',
        end: '9',
        idx: '11',
        order: 2,
      },
      12: {
        start: '9',
        end: '10',
        idx: '12',
        order: 1,
      },
      13: {
        start: '10',
        end: '11',
        idx: '13',
        order: 2,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
      15: {
        start: '12',
        end: '13',
        idx: '15',
        order: 2,
      },
    },
    positions: {
      0: [550, -136.603, 0],
      1: [500, -50, 0],
      2: [400, -50, 0],
      3: [350, -136.603, 0],
      4: [250, -136.603, 0],
      5: [200, -223.205, 0],
      6: [100, -223.205, 0],
      7: [50, -309.808, 0],
      8: [100, -396.41, 0],
      9: [200, -396.41, 0],
      10: [250, -309.808, 0],
      11: [350, -309.808, 0],
      12: [400, -223.205, 0],
      13: [500, -223.205, 0],
    },
    key: 'Anthracene',
  },
  'Phenanthrene': {
    nextAtom: 14,
    nextBond: 16,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'C', charge: 0, idx: '9' },
      10: { element: 'C', charge: 0, idx: '10' },
      11: { element: 'C', charge: 0, idx: '11' },
      12: { element: 'C', charge: 0, idx: '12' },
      13: { element: 'C', charge: 0, idx: '13' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '13',
        idx: '5',
        order: 1,
      },
      6: {
        start: '4',
        end: '5',
        idx: '6',
        order: 2,
      },
      7: {
        start: '4',
        end: '6',
        idx: '7',
        order: 1,
      },
      8: {
        start: '6',
        end: '7',
        idx: '8',
        order: 2,
      },
      9: {
        start: '7',
        end: '8',
        idx: '9',
        order: 1,
      },
      10: {
        start: '8',
        end: '9',
        idx: '10',
        order: 2,
      },
      11: {
        start: '8',
        end: '13',
        idx: '11',
        order: 1,
      },
      12: {
        start: '9',
        end: '10',
        idx: '12',
        order: 1,
      },
      13: {
        start: '10',
        end: '11',
        idx: '13',
        order: 2,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
      15: {
        start: '12',
        end: '13',
        idx: '15',
        order: 2,
      },
    },
    positions: {
      0: [550, -223.205, 0],
      1: [500, -309.808, 0],
      2: [400, -309.808, 0],
      3: [350, -223.205, 0],
      4: [400, -136.603, 0],
      5: [500, -136.603, 0],
      6: [350, -50, 0],
      7: [250, -50, 0],
      8: [200, -136.603, 0],
      9: [100, -136.603, 0],
      10: [50, -223.205, 0],
      11: [100, -309.808, 0],
      12: [200, -309.808, 0],
      13: [250, -223.205, 0],
    },
    key: 'Phenanthrene',
  },
  'Cyclopentadiene': {
    nextAtom: 5,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 2,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
    },
    positions: {
      0: [145.106, -50, 0],
      1: [50, -80.902, 0],
      2: [50, -180.902, 0],
      3: [145.106, -211.803, 0],
      4: [203.884, -130.902, 0],
    },
    key: 'Cyclopentadiene',
  },
  'Alanine': {
    nextAtom: 6,
    nextBond: 5,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
    },
    bonds: {
      0: {
        start: '1',
        end: '0',
        idx: '0',
        order: 1,
        type: 'dashed',
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '5',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '4',
        idx: '4',
        order: 1,
      },
    },
    positions: {
      0: [50, -136.603, 0],
      1: [150, -136.603, 0],
      2: [200, -223.205, 0],
      3: [150, -309.808, 0],
      4: [300, -223.205, 0],
      5: [200, -50, 0],
    },
    key: 'Alanine',
  },
  'Arginine': {
    nextAtom: 12,
    nextBond: 11,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'O', charge: 0, idx: '5' },
      6: { element: 'N', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
      9: { element: 'C', charge: 0, idx: '9' },
      10: { element: 'N', charge: 0, idx: '10' },
      11: { element: 'N', charge: 0, idx: '11' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '7',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '2',
        end: '6',
        idx: '4',
        order: 1,
        type: 'wedge',
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 2,
      },
      6: {
        start: '3',
        end: '5',
        idx: '6',
        order: 1,
      },
      7: {
        start: '7',
        end: '8',
        idx: '7',
        order: 1,
      },
      8: {
        start: '8',
        end: '9',
        idx: '8',
        order: 2,
      },
      9: {
        start: '9',
        end: '10',
        idx: '9',
        order: 1,
      },
      10: {
        start: '9',
        end: '11',
        idx: '10',
        order: 1,
      },
    },
    positions: {
      0: [200, -396.41, 0],
      1: [300, -396.41, 0],
      2: [350, -309.808, 0],
      3: [450, -309.808, 0],
      4: [500, -223.205, 0],
      5: [500, -396.41, 0],
      6: [300, -223.205, 0],
      7: [150, -309.808, 0],
      8: [200, -223.205, 0],
      9: [150, -136.603, 0],
      10: [50, -136.603, 0],
      11: [200, -50, 0],
    },
    key: 'Arginine',
  },
  'Asparagine': {
    nextAtom: 9,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'O', charge: -1, idx: '4' },
      5: { element: 'N', charge: 1, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '1',
        end: '5',
        idx: '3',
        order: 1,
        type: 'wedge',
      },
      4: {
        start: '2',
        end: '3',
        idx: '4',
        order: 2,
      },
      5: {
        start: '2',
        end: '4',
        idx: '5',
        order: 1,
      },
      6: {
        start: '6',
        end: '7',
        idx: '6',
        order: 2,
      },
      7: {
        start: '6',
        end: '8',
        idx: '7',
        order: 1,
      },
    },
    positions: {
      0: [200, -223.205, 0],
      1: [300, -223.205, 0],
      2: [350, -309.808, 0],
      3: [450, -309.808, 0],
      4: [300, -396.41, 0],
      5: [350, -136.603, 0],
      6: [150, -136.603, 0],
      7: [200, -50, 0],
      8: [50, -136.603, 0],
    },
    key: 'Asparagine',
  },
  'Aspartic acid': {
    nextAtom: 9,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'O', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '1',
        end: '5',
        idx: '3',
        order: 1,
        type: 'dashed',
      },
      4: {
        start: '2',
        end: '3',
        idx: '4',
        order: 2,
      },
      5: {
        start: '2',
        end: '4',
        idx: '5',
        order: 1,
      },
      6: {
        start: '6',
        end: '7',
        idx: '6',
        order: 2,
      },
      7: {
        start: '6',
        end: '8',
        idx: '7',
        order: 1,
      },
    },
    positions: {
      0: [200, -223.205, 0],
      1: [300, -223.205, 0],
      2: [350, -136.603, 0],
      3: [300, -50, 0],
      4: [450, -136.603, 0],
      5: [350, -309.808, 0],
      6: [150, -136.603, 0],
      7: [200, -50, 0],
      8: [50, -136.603, 0],
    },
    key: 'Aspartic acid',
  },
  'Cysteine': {
    nextAtom: 7,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
      6: { element: 'S', charge: 0, idx: '6' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '1',
        end: '5',
        idx: '3',
        order: 1,
        type: 'wedge',
      },
      4: {
        start: '2',
        end: '3',
        idx: '4',
        order: 2,
      },
      5: {
        start: '2',
        end: '4',
        idx: '5',
        order: 1,
      },
    },
    positions: {
      0: [100, -223.205, 0],
      1: [200, -223.205, 0],
      2: [250, -136.603, 0],
      3: [350, -136.603, 0],
      4: [200, -50, 0],
      5: [250, -309.808, 0],
      6: [50, -309.808, 0],
    },
    key: 'Cysteine',
  },
  'Glutamine': {
    nextAtom: 10,
    nextBond: 9,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'O', charge: 0, idx: '8' },
      9: { element: 'N', charge: 0, idx: '9' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '5',
        end: '6',
        idx: '5',
        order: 1,
      },
      6: {
        start: '5',
        end: '9',
        idx: '6',
        order: 1,
        type: 'dashed',
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 2,
      },
      8: {
        start: '6',
        end: '8',
        idx: '8',
        order: 1,
      },
    },
    positions: {
      0: [250, -223.205, 0],
      1: [350, -223.205, 0],
      2: [400, -136.603, 0],
      3: [500, -136.603, 0],
      4: [350, -50, 0],
      5: [200, -136.603, 0],
      6: [100, -136.603, 0],
      7: [50, -50, 0],
      8: [50, -223.205, 0],
      9: [250, -50, 0],
    },
    key: 'Glutamine',
  },
  'Glutamic acid': {
    nextAtom: 10,
    nextBond: 9,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'O', charge: 0, idx: '8' },
      9: { element: 'N', charge: 0, idx: '9' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '5',
        end: '6',
        idx: '5',
        order: 1,
      },
      6: {
        start: '5',
        end: '9',
        idx: '6',
        order: 1,
        type: 'wedge',
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 2,
      },
      8: {
        start: '6',
        end: '8',
        idx: '8',
        order: 1,
      },
    },
    positions: {
      0: [250, -223.205, 0],
      1: [350, -223.205, 0],
      2: [400, -309.808, 0],
      3: [350, -396.41, 0],
      4: [500, -309.808, 0],
      5: [200, -136.603, 0],
      6: [100, -136.603, 0],
      7: [50, -50, 0],
      8: [50, -223.205, 0],
      9: [250, -50, 0],
    },
    key: 'Glutamic acid',
  },
  'Glycine': {
    nextAtom: 5,
    nextBond: 4,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'O', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 2,
      },
      3: {
        start: '1',
        end: '3',
        idx: '3',
        order: 1,
      },
    },
    positions: {
      0: [100, -136.603, 0],
      1: [200, -136.603, 0],
      2: [250, -50, 0],
      3: [250, -223.205, 0],
      4: [50, -50, 0],
    },
    key: 'Glycine',
  },
  'Histidine': {
    nextAtom: 11,
    nextBond: 11,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'O', charge: 0, idx: '8' },
      9: { element: 'O', charge: 0, idx: '9' },
      10: { element: 'N', charge: 0, idx: '10' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '1',
        end: '5',
        idx: '3',
        order: 1,
      },
      4: {
        start: '2',
        end: '3',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 2,
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 1,
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 1,
      },
      8: {
        start: '6',
        end: '10',
        idx: '8',
        order: 1,
        type: 'wedge',
      },
      9: {
        start: '7',
        end: '8',
        idx: '9',
        order: 2,
      },
      10: {
        start: '7',
        end: '9',
        idx: '10',
        order: 1,
      },
    },
    positions: {
      0: [141.355, -148.891, 0],
      1: [208.268, -223.205, 0],
      2: [158.268, -309.808, 0],
      3: [60.453, -289.016, 0],
      4: [50, -189.564, 0],
      5: [308.268, -223.205, 0],
      6: [358.268, -136.603, 0],
      7: [458.268, -136.603, 0],
      8: [508.268, -223.205, 0],
      9: [508.268, -50, 0],
      10: [308.268, -50, 0],
    },
    key: 'Histidine',
  },
  'Isoleucine': {
    nextAtom: 9,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 1,
      },
      2: {
        start: '2',
        end: '3',
        idx: '2',
        order: 1,
        type: 'wedge',
      },
      3: {
        start: '2',
        end: '4',
        idx: '3',
        order: 1,
      },
      4: {
        start: '4',
        end: '5',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '8',
        idx: '5',
        order: 1,
        type: 'wedge',
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '7',
        idx: '7',
        order: 1,
      },
    },
    positions: {
      0: [100, -50, 0],
      1: [200, -50, 0],
      2: [250, -136.603, 0],
      3: [350, -136.603, 0],
      4: [200, -223.205, 0],
      5: [100, -223.205, 0],
      6: [50, -309.808, 0],
      7: [50, -136.603, 0],
      8: [250, -309.808, 0],
    },
    key: 'Isoleucine',
  },
  'Leucine': {
    nextAtom: 9,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '3',
        idx: '2',
        order: 1,
      },
      3: {
        start: '3',
        end: '4',
        idx: '3',
        order: 1,
      },
      4: {
        start: '4',
        end: '5',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '8',
        idx: '5',
        order: 1,
        type: 'wedge',
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '7',
        idx: '7',
        order: 1,
      },
    },
    positions: {
      0: [50, -396.41, 0],
      1: [150, -396.41, 0],
      2: [200, -483.013, 0],
      3: [200, -309.808, 0],
      4: [150, -223.205, 0],
      5: [200, -136.603, 0],
      6: [150, -50, 0],
      7: [300, -136.603, 0],
      8: [50, -223.205, 0],
    },
    key: 'Leucine',
  },
  'Lysine': {
    nextAtom: 10,
    nextBond: 9,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'O', charge: 0, idx: '8' },
      9: { element: 'N', charge: 0, idx: '9' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '4',
        end: '5',
        idx: '4',
        order: 1,
      },
      5: {
        start: '5',
        end: '6',
        idx: '5',
        order: 1,
      },
      6: {
        start: '5',
        end: '9',
        idx: '6',
        order: 1,
        type: 'dashed',
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 2,
      },
      8: {
        start: '6',
        end: '8',
        idx: '8',
        order: 1,
      },
    },
    positions: {
      0: [350, -223.205, 0],
      1: [450, -223.205, 0],
      2: [500, -309.808, 0],
      3: [600, -309.808, 0],
      4: [300, -136.603, 0],
      5: [200, -136.603, 0],
      6: [150, -223.205, 0],
      7: [50, -223.205, 0],
      8: [200, -309.808, 0],
      9: [150, -50, 0],
    },
    key: 'Lysine',
  },
  'Methionine': {
    nextAtom: 9,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'S', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 1,
      },
      2: {
        start: '2',
        end: '3',
        idx: '2',
        order: 1,
      },
      3: {
        start: '3',
        end: '4',
        idx: '3',
        order: 1,
      },
      4: {
        start: '4',
        end: '5',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '8',
        idx: '5',
        order: 1,
        type: 'dashed',
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '7',
        idx: '7',
        order: 1,
      },
    },
    positions: {
      0: [50, -50, 0],
      1: [150, -50, 0],
      2: [200, -136.603, 0],
      3: [150, -223.205, 0],
      4: [200, -309.808, 0],
      5: [150, -396.41, 0],
      6: [200, -483.013, 0],
      7: [50, -396.41, 0],
      8: [300, -309.808, 0],
    },
    key: 'Methionine',
  },
  'Phenylalanine': {
    nextAtom: 12,
    nextBond: 12,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'O', charge: 0, idx: '9' },
      10: { element: 'O', charge: 0, idx: '10' },
      11: { element: 'N', charge: 1, idx: '11' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '6',
        idx: '5',
        order: 1,
      },
      6: {
        start: '4',
        end: '5',
        idx: '6',
        order: 2,
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 1,
      },
      8: {
        start: '7',
        end: '8',
        idx: '8',
        order: 1,
      },
      9: {
        start: '7',
        end: '11',
        idx: '9',
        order: 1,
        type: 'dashed',
      },
      10: {
        start: '8',
        end: '9',
        idx: '10',
        order: 2,
      },
      11: {
        start: '8',
        end: '10',
        idx: '11',
        order: 1,
      },
    },
    positions: {
      0: [50, -136.603, 0],
      1: [100, -223.205, 0],
      2: [200, -223.205, 0],
      3: [250, -136.603, 0],
      4: [200, -50, 0],
      5: [100, -50, 0],
      6: [350, -136.603, 0],
      7: [400, -223.205, 0],
      8: [500, -223.205, 0],
      9: [550, -309.808, 0],
      10: [550, -136.603, 0],
      11: [350, -309.808, 0],
    },
    key: 'Phenylalanine',
  },
  'Proline': {
    nextAtom: 8,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '2',
        end: '5',
        idx: '4',
        order: 1,
        type: 'wedge',
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 1,
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '7',
        idx: '7',
        order: 1,
      },
    },
    positions: {
      0: [60.453, -70.791, 0],
      1: [158.268, -50, 0],
      2: [208.268, -136.603, 0],
      3: [141.355, -210.917, 0],
      4: [50, -170.243, 0],
      5: [308.268, -136.603, 0],
      6: [358.268, -50, 0],
      7: [358.268, -223.205, 0],
    },
    key: 'Proline',
  },
  'Serine': {
    nextAtom: 7,
    nextBond: 6,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '1',
        end: '5',
        idx: '3',
        order: 1,
        type: 'dashed',
      },
      4: {
        start: '2',
        end: '3',
        idx: '4',
        order: 2,
      },
      5: {
        start: '2',
        end: '4',
        idx: '5',
        order: 1,
      },
    },
    positions: {
      0: [100, -223.205, 0],
      1: [200, -223.205, 0],
      2: [250, -136.603, 0],
      3: [350, -136.603, 0],
      4: [200, -50, 0],
      5: [250, -309.808, 0],
      6: [50, -136.603, 0],
    },
    key: 'Serine',
  },
  'Threonine': {
    nextAtom: 8,
    nextBond: 7,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'O', charge: 0, idx: '5' },
      6: { element: 'N', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
    },
    bonds: {
      0: {
        start: '1',
        end: '0',
        idx: '0',
        order: 1,
        type: 'wedge',
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '7',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '2',
        end: '6',
        idx: '4',
        order: 1,
        type: 'dashed',
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 2,
      },
      6: {
        start: '3',
        end: '5',
        idx: '6',
        order: 1,
      },
    },
    positions: {
      0: [50, -309.808, 0],
      1: [150, -309.808, 0],
      2: [200, -223.205, 0],
      3: [150, -136.603, 0],
      4: [50, -136.603, 0],
      5: [200, -50, 0],
      6: [300, -223.205, 0],
      7: [200, -396.41, 0],
    },
    key: 'Threonine',
  },
  'Tryptophan': {
    nextAtom: 15,
    nextBond: 16,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
      9: { element: 'C', charge: 0, idx: '9' },
      10: { element: 'C', charge: 0, idx: '10' },
      11: { element: 'C', charge: 0, idx: '11' },
      12: { element: 'O', charge: 0, idx: '12' },
      13: { element: 'O', charge: 0, idx: '13' },
      14: { element: 'N', charge: 0, idx: '14' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '8',
        idx: '5',
        order: 1,
      },
      6: {
        start: '4',
        end: '5',
        idx: '6',
        order: 2,
      },
      7: {
        start: '4',
        end: '6',
        idx: '7',
        order: 1,
      },
      8: {
        start: '6',
        end: '7',
        idx: '8',
        order: 2,
      },
      9: {
        start: '6',
        end: '9',
        idx: '9',
        order: 1,
      },
      10: {
        start: '7',
        end: '8',
        idx: '10',
        order: 1,
      },
      11: {
        start: '9',
        end: '10',
        idx: '11',
        order: 1,
      },
      12: {
        start: '10',
        end: '11',
        idx: '12',
        order: 1,
      },
      13: {
        start: '10',
        end: '14',
        idx: '13',
        order: 1,
        type: 'wedge',
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 2,
      },
      15: {
        start: '11',
        end: '13',
        idx: '15',
        order: 1,
      },
    },
    positions: {
      0: [151.807, -455.75, 0],
      1: [60.453, -415.077, 0],
      2: [50, -315.625, 0],
      3: [130.902, -256.846, 0],
      4: [222.256, -297.52, 0],
      5: [232.709, -396.972, 0],
      6: [289.169, -223.205, 0],
      7: [239.169, -136.603, 0],
      8: [141.355, -157.394, 0],
      9: [389.169, -223.205, 0],
      10: [439.169, -136.603, 0],
      11: [539.169, -136.603, 0],
      12: [589.169, -223.205, 0],
      13: [589.169, -50, 0],
      14: [389.169, -50, 0],
    },
    key: 'Tryptophan',
  },
  'Tyrosine': {
    nextAtom: 13,
    nextBond: 13,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'O', charge: 0, idx: '9' },
      10: { element: 'O', charge: 0, idx: '10' },
      11: { element: 'N', charge: 0, idx: '11' },
      12: { element: 'O', charge: 0, idx: '12' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '5',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '12',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 1,
      },
      6: {
        start: '4',
        end: '5',
        idx: '6',
        order: 2,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 1,
      },
      8: {
        start: '6',
        end: '7',
        idx: '8',
        order: 1,
      },
      9: {
        start: '7',
        end: '8',
        idx: '9',
        order: 1,
      },
      10: {
        start: '7',
        end: '11',
        idx: '10',
        order: 1,
        type: 'dashed',
      },
      11: {
        start: '8',
        end: '9',
        idx: '11',
        order: 2,
      },
      12: {
        start: '8',
        end: '10',
        idx: '12',
        order: 1,
      },
    },
    positions: {
      0: [350, -223.205, 0],
      1: [450, -223.205, 0],
      2: [500, -136.603, 0],
      3: [450, -50, 0],
      4: [350, -50, 0],
      5: [300, -136.603, 0],
      6: [200, -136.603, 0],
      7: [150, -223.205, 0],
      8: [200, -309.808, 0],
      9: [150, -396.41, 0],
      10: [300, -309.808, 0],
      11: [50, -223.205, 0],
      12: [600, -136.603, 0],
    },
    key: 'Tyrosine',
  },
  'Valine': {
    nextAtom: 8,
    nextBond: 7,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'O', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
      7: { element: 'N', charge: 0, idx: '7' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '3',
        idx: '2',
        order: 1,
      },
      3: {
        start: '3',
        end: '4',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '7',
        idx: '4',
        order: 1,
        type: 'dashed',
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
      6: {
        start: '4',
        end: '6',
        idx: '6',
        order: 1,
      },
    },
    positions: {
      0: [50, -136.603, 0],
      1: [150, -136.603, 0],
      2: [200, -50, 0],
      3: [200, -223.205, 0],
      4: [300, -223.205, 0],
      5: [350, -309.808, 0],
      6: [350, -136.603, 0],
      7: [150, -309.808, 0],
    },
    key: 'Valine',
  },
  'Adenine': {
    nextAtom: 10,
    nextBond: 11,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'N', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'N', charge: 0, idx: '8' },
      9: { element: 'N', charge: 0, idx: '9' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '8',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 1,
      },
      6: {
        start: '3',
        end: '5',
        idx: '6',
        order: 1,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 2,
      },
      8: {
        start: '5',
        end: '9',
        idx: '8',
        order: 1,
      },
      9: {
        start: '6',
        end: '7',
        idx: '9',
        order: 1,
      },
      10: {
        start: '7',
        end: '8',
        idx: '10',
        order: 2,
      },
    },
    positions: {
      0: [150, -50, 0],
      1: [69.098, -108.779, 0],
      2: [100, -203.884, 0],
      3: [200, -203.884, 0],
      4: [230.902, -108.779, 0],
      5: [250, -290.487, 0],
      6: [200, -377.089, 0],
      7: [100, -377.089, 0],
      8: [50, -290.487, 0],
      9: [350, -290.487, 0],
    },
    key: 'Adenine',
  },
  'Guanine': {
    nextAtom: 11,
    nextBond: 12,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'N', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'O', charge: 0, idx: '6' },
      7: { element: 'N', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'N', charge: 0, idx: '9' },
      10: { element: 'N', charge: 0, idx: '10' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '4',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '9',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 1,
      },
      6: {
        start: '3',
        end: '5',
        idx: '6',
        order: 1,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 2,
      },
      8: {
        start: '5',
        end: '7',
        idx: '8',
        order: 1,
      },
      9: {
        start: '7',
        end: '8',
        idx: '9',
        order: 2,
      },
      10: {
        start: '8',
        end: '9',
        idx: '10',
        order: 1,
      },
      11: {
        start: '8',
        end: '10',
        idx: '11',
        order: 1,
      },
    },
    positions: {
      0: [150, -463.692, 0],
      1: [69.098, -404.913, 0],
      2: [100, -309.808, 0],
      3: [200, -309.808, 0],
      4: [230.902, -404.913, 0],
      5: [250, -223.205, 0],
      6: [350, -223.205, 0],
      7: [200, -136.603, 0],
      8: [100, -136.603, 0],
      9: [50, -223.205, 0],
      10: [50, -50, 0],
    },
    key: 'Guanine',
  },
  'Inosine': {
    nextAtom: 19,
    nextBond: 21,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'N', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'O', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'C', charge: 0, idx: '5' },
      6: { element: 'N', charge: 0, idx: '6' },
      7: { element: 'N', charge: 0, idx: '7' },
      8: { element: 'C', charge: 0, idx: '8' },
      9: { element: 'N', charge: 0, idx: '9' },
      10: { element: 'C', charge: 0, idx: '10' },
      11: { element: 'C', charge: 0, idx: '11' },
      12: { element: 'C', charge: 0, idx: '12' },
      13: { element: 'C', charge: 0, idx: '13' },
      14: { element: 'O', charge: 0, idx: '14' },
      15: { element: 'C', charge: 0, idx: '15' },
      16: { element: 'O', charge: 0, idx: '16' },
      17: { element: 'O', charge: 0, idx: '17' },
      18: { element: 'O', charge: 0, idx: '18' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 2,
      },
      4: {
        start: '2',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
      6: {
        start: '4',
        end: '9',
        idx: '6',
        order: 1,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 1,
      },
      8: {
        start: '5',
        end: '7',
        idx: '8',
        order: 1,
      },
      9: {
        start: '7',
        end: '8',
        idx: '9',
        order: 1,
      },
      10: {
        start: '10',
        end: '7',
        idx: '10',
        order: 1,
        type: 'wedge',
      },
      11: {
        start: '8',
        end: '9',
        idx: '11',
        order: 2,
      },
      12: {
        start: '10',
        end: '11',
        idx: '12',
        order: 1,
      },
      13: {
        start: '10',
        end: '14',
        idx: '13',
        order: 1,
      },
      14: {
        start: '11',
        end: '12',
        idx: '14',
        order: 1,
      },
      15: {
        start: '11',
        end: '18',
        idx: '15',
        order: 1,
        type: 'wedge',
      },
      16: {
        start: '12',
        end: '13',
        idx: '16',
        order: 1,
      },
      17: {
        start: '12',
        end: '17',
        idx: '17',
        order: 1,
        type: 'wedge',
      },
      18: {
        start: '13',
        end: '14',
        idx: '18',
        order: 1,
      },
      19: {
        start: '13',
        end: '15',
        idx: '19',
        order: 1,
        type: 'dashed',
      },
      20: {
        start: '15',
        end: '16',
        idx: '20',
        order: 1,
      },
    },
    positions: {
      0: [505.248, -50, 0],
      1: [605.248, -50, 0],
      2: [655.248, -136.603, 0],
      3: [755.248, -136.603, 0],
      4: [605.248, -223.205, 0],
      5: [505.248, -223.205, 0],
      6: [455.248, -136.603, 0],
      7: [474.346, -318.311, 0],
      8: [555.248, -377.089, 0],
      9: [636.149, -318.311, 0],
      10: [376.531, -339.102, 0],
      11: [345.63, -434.208, 0],
      12: [245.63, -434.208, 0],
      13: [214.728, -339.102, 0],
      14: [295.629, -280.323, 0],
      15: [116.913, -318.311, 0],
      16: [50, -392.625, 0],
      17: [178.716, -508.522, 0],
      18: [412.543, -508.522, 0],
    },
    key: 'Inosine',
  },
  'Cytosine': {
    nextAtom: 8,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'N', charge: 0, idx: '7' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '1',
        end: '7',
        idx: '3',
        order: 1,
      },
      4: {
        start: '2',
        end: '3',
        idx: '4',
        order: 1,
      },
      5: {
        start: '3',
        end: '4',
        idx: '5',
        order: 2,
      },
      6: {
        start: '3',
        end: '5',
        idx: '6',
        order: 1,
      },
      7: {
        start: '5',
        end: '6',
        idx: '7',
        order: 2,
      },
    },
    positions: {
      0: [200, -309.808, 0],
      1: [250, -223.205, 0],
      2: [200, -136.603, 0],
      3: [100, -136.603, 0],
      4: [50, -50, 0],
      5: [50, -223.205, 0],
      6: [100, -309.808, 0],
      7: [350, -223.205, 0],
    },
    key: 'Cytosine',
  },
  'Thymine': {
    nextAtom: 9,
    nextBond: 9,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'C', charge: 0, idx: '2' },
      3: { element: 'N', charge: 0, idx: '3' },
      4: { element: 'C', charge: 0, idx: '4' },
      5: { element: 'O', charge: 0, idx: '5' },
      6: { element: 'N', charge: 0, idx: '6' },
      7: { element: 'C', charge: 0, idx: '7' },
      8: { element: 'O', charge: 0, idx: '8' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 1,
      },
      1: {
        start: '1',
        end: '2',
        idx: '1',
        order: 2,
      },
      2: {
        start: '1',
        end: '7',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 1,
      },
      5: {
        start: '4',
        end: '5',
        idx: '5',
        order: 2,
      },
      6: {
        start: '4',
        end: '6',
        idx: '6',
        order: 1,
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 1,
      },
      8: {
        start: '7',
        end: '8',
        idx: '8',
        order: 2,
      },
    },
    positions: {
      0: [50, -223.205, 0],
      1: [150, -223.205, 0],
      2: [200, -309.808, 0],
      3: [300, -309.808, 0],
      4: [350, -223.205, 0],
      5: [450, -223.205, 0],
      6: [300, -136.603, 0],
      7: [200, -136.603, 0],
      8: [150, -50, 0],
    },
    key: 'Thymine',
  },
  'Uracil': {
    nextAtom: 8,
    nextBond: 8,
    atoms: {
      0: { element: 'C', charge: 0, idx: '0' },
      1: { element: 'C', charge: 0, idx: '1' },
      2: { element: 'N', charge: 0, idx: '2' },
      3: { element: 'C', charge: 0, idx: '3' },
      4: { element: 'O', charge: 0, idx: '4' },
      5: { element: 'N', charge: 0, idx: '5' },
      6: { element: 'C', charge: 0, idx: '6' },
      7: { element: 'O', charge: 0, idx: '7' },
    },
    bonds: {
      0: {
        start: '0',
        end: '1',
        idx: '0',
        order: 2,
      },
      1: {
        start: '0',
        end: '6',
        idx: '1',
        order: 1,
      },
      2: {
        start: '1',
        end: '2',
        idx: '2',
        order: 1,
      },
      3: {
        start: '2',
        end: '3',
        idx: '3',
        order: 1,
      },
      4: {
        start: '3',
        end: '4',
        idx: '4',
        order: 2,
      },
      5: {
        start: '3',
        end: '5',
        idx: '5',
        order: 1,
      },
      6: {
        start: '5',
        end: '6',
        idx: '6',
        order: 1,
      },
      7: {
        start: '6',
        end: '7',
        idx: '7',
        order: 2,
      },
    },
    positions: {
      0: [50, -223.205, 0],
      1: [100, -309.808, 0],
      2: [200, -309.808, 0],
      3: [250, -223.205, 0],
      4: [350, -223.205, 0],
      5: [200, -136.603, 0],
      6: [100, -136.603, 0],
      7: [50, -50, 0],
    },
    key: 'Uracil',
  },
};

export const cycloalkanes = {
  3: exampleMols.Cyclopropane,
  4: exampleMols.Cyclobutane,
  5: exampleMols.Cyclopentane,
  6: exampleMols.Cyclohexane,
  7: exampleMols.Cycloheptane,
  8: exampleMols.Cyclooctane,
  9: exampleMols.Cyclononane,
};

Object.entries(exampleMols).forEach(([key, mol]) => {
  (mol as any).key = key;
});
